import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Healthmemberdata extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.healthmemberdata_Id,
          sortable: true,
          cell: (row) => <span>{row.healthmemberdata_Id}</span>,
        },
        {
          name: "Employee Id",
          selector: (row, i) => row.employeeid,
          sortable: true,
          cell: (row) => <span>{row.employeeid}</span>,
        },
        {
          name: "Company Id",
          selector: (row, i) => row.companyid,
          sortable: true,
          cell: (row) => <span>{row.companyid}</span>,
        },
        {
          name: "Member Full Name",
          selector: (row, i) => row.memberfullname,
          sortable: true,
          cell: (row) => <span>{row.memberfullname}</span>,
        },
        {
          name: "Member First Name",
          selector: (row, i) => row.memberfirstname,
          sortable: true,
          cell: (row) => <span>{row.memberfirstname}</span>,
        },
        {
          name: "Member Last Name",
          selector: (row, i) => row.memberlastname,
          sortable: true,
          cell: (row) => <span>{row.memberlastname}</span>,
        },
        {
          name: "Relation With Employee",
          selector: (row, i) => row.relationwithemployee,
          sortable: true,
          cell: (row) => <span>{row.relationwithemployee}</span>,
        },
        {
          name: "Sum Insured",
          selector: (row, i) => row.suminsured,
          sortable: true,
          cell: (row) => <span>{row.suminsured}</span>,
        },
        {
          name: "Pincode",
          selector: (row, i) => row.pincode,
          sortable: true,
          cell: (row) => <span>{row.pincode}</span>,
        },
        {
          name: "Gender",
          selector: (row, i) => row.gender,
          sortable: true,
          cell: (row) => <span>{row.gender}</span>,
        },
        {
          name: "Date Of Birth",
          selector: (row, i) => row.dob,
          sortable: true,
          cell: (row) => <span>{row.dob}</span>,
        },
        {
          name: "Mobile Number",
          selector: (row, i) => row.mobilenumber,
          sortable: true,
          cell: (row) => <span>{row.mobilenumber}</span>,
        },
        {
          name: "Email Id",
          selector: (row, i) => row.emailId,
          sortable: true,
          cell: (row) => <span>{row.emailId}</span>,
        },
        {
          name: "Employee Height",
          selector: (row, i) => row.employeeheight,
          sortable: true,
          cell: (row) => <span>{row.employeeheight}</span>,
        },
        {
          name: "Employee Weight",
          selector: (row, i) => row.employeeweight,
          sortable: true,
          cell: (row) => <span>{row.employeeweight}</span>,
        },
        {
          name: "BMI ",
          selector: (row, i) => row.bmi,
          sortable: true,
          cell: (row) => <span>{row.bmi}</span>,
        },
        {
          name: "Pan Number",
          selector: (row, i) => row.pannumber,
          sortable: true,
          cell: (row) => <span>{row.pannumber}</span>,
        },
        {
          name: "Aadhar Number",
          selector: (row, i) => row.aadharnumber,
          sortable: true,
          cell: (row) => <span>{row.aadharnumber}</span>,
        },
        {
          name: "Designation",
          selector: (row, i) => row.designation,
          sortable: true,
          cell: (row) => <span>{row.designation}</span>,
        },
        {
          name: "Alternate Number",
          selector: (row, i) => row.alternatenumber,
          sortable: true,
          cell: (row) => <span>{row.alternatenumber}</span>,
        },
        {
          name: "Marital Status",
          selector: (row, i) => row.maritalstatus,
          sortable: true,
          cell: (row) => <span>{row.maritalstatus}</span>,
        },
        {
          name: "City",
          selector: (row, i) => row.city,
          sortable: true,
          cell: (row) => <span>{row.city}</span>,
        },
        {
          name: "State",
          selector: (row, i) => row.state,
          sortable: true,
          cell: (row) => <span>{row.state}</span>,
        },
        {
          name: "Member Status",
          selector: (row, i) => row.memberstatus,
          sortable: true,
          cell: (row) => <span>{row.memberstatus}</span>,
        },
        {
          name: "Employment Status",
          selector: (row, i) => row.employmentstatus,
          sortable: true,
          cell: (row) => <span>{row.employmentstatus}</span>,
        },
        {
          name: "AddressLine one",
          selector: (row, i) => row.addresslineone,
          sortable: true,
          cell: (row) => <span>{row.addresslineone}</span>,
        },
        {
          name: "Addressline Two",
          selector: (row, i) => row.addresslinetwo,
          sortable: true,
          cell: (row) => <span>{row.addresslinetwo}</span>,
        },
        {
          name: "Annual income",
          selector: (row, i) => row.annualincome,
          sortable: true,
          cell: (row) => <span>{row.annualincome}</span>,
        },
        {
          name: "Maternity cover",
          selector: (row, i) => row.maternitycover,
          sortable: true,
          cell: (row) => <span>{row.maternitycover}</span>,
        },
        {
          name: "Emp DOJ",
          selector: (row, i) => row.employeedateofjoining,
          sortable: true,
          cell: (row) => <span>{row.employeedateofjoining}</span>,
        },
        {
          name: "Freeze date",
          selector: (row, i) => row.freezedate,
          sortable: true,
          cell: (row) => <span>{row.freezedate}</span>,
        },
        {
          name: "Health DOJ",
          selector: (row, i) => row.healthdateofjoining,
          sortable: true,
          cell: (row) => <span>{row.healthdateofjoining}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                variant="primary"
                onClick={() => this.handleEnterEditMode(row)}
                className="bi bi-pen"
                style={{ marginRight: "3px" }}
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      employeeid: "",
      companyid: "",
      memberfullname: "",
      memberfirstname: "",
      memberlastname: "",
      relationwithemployee: "",
      suminsured: "",
      pincode: "",
      gender: "",
      dob: "",
      mobilenumber: "",
      emailId: "",
      employeeheight: "",
      employeeweight: "",
      bmi: "",
      pannumber: "",
      aadharnumber: "",
      designation: "",
      alternatenumber: "",
      maritalstatus: "",
      city: "",
      state: "",
      memberstatus: "",
      employmentstatus: "",
      addresslineone: "",
      addresslinetwo: "",
      healthmemberdata_Id: "",
      isEditing: false, // Flag to indicate edit mode
      isNewEntry: false,
      dataone: [],
      datatwo: [],
    };
  }
  handleEnterEditMode = (row) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    this.setState({
      employeeid: row.employeeid,
      companyid: row.companyid,
      memberfullname: row.memberfullname,
      memberfirstname: row.memberfirstname,
      memberlastname: row.memberlastname,
      relationwithemployee: row.relationwithemployee,
      suminsured: row.suminsured,
      pincode: row.pincode,
      gender: row.gender,
      dob: row.dob,
      mobilenumber: row.mobilenumber,
      emailId: row.emailId,
      employeeheight: row.employeeheight,
      employeeweight: row.employeeweight,
      bmi: row.bmi,
      pannumber: row.pannumber,
      aadharnumber: row.aadharnumber,
      designation: row.designation,
      alternatenumber: row.alternatenumber,
      maritalstatus: row.maritalstatus,
      city: row.city,
      state: row.state,
      memberstatus: row.memberstatus,
      employmentstatus: row.employmentstatus,
      addresslineone: row.addresslineone,
      addresslinetwo: row.addresslinetwo,
      healthmemberdata_Id: row.healthmemberdata_Id,
      isEditing: true,
    });
  };
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ show: true });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  HealthmemberdataeditHandler = (e) => {
    e.preventDefault();
    // const updateFormData = {...editFormData};
    // updateFormData['Healthmemberdata_Id'] = e.target.parentElement.getAttribute("id");
    // setEditFormData(updateFormData);
    // setEdit(true);
  };

  HealthmemberdatafetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Healthmemberdata/list", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.list.length > 0) {
          const companyidFromApi = data.list[0].companyid;
          this.setState({ data: data.list });

          // Call second API directly with companyidFromApi
          this.HealthmemberdatastatusmemberfetchHandler(companyidFromApi);
          this.HealthmemberdatastatuscountfetchHandler(companyidFromApi);
        }
      });
  };
  HealthmemberdatastatusmemberfetchHandler = (companyid) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyid", companyid);
    fetch(configData.api_url + "C_Healthmemberdata/get_status1_members", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ dataone: data.list });
        }
      });
  };
  HealthmemberdatastatuscountfetchHandler = (companyid) => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("companyid", companyid);
    fetch(configData.api_url + "C_Healthmemberdata/get_company_status_counts", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ datatwo: data.list });
        }
      });
  };
  HealthmemberdatasubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("employeeid", this.state.employeeid);
    formData.append("companyid", this.state.companyid);
    formData.append("memberfullname", this.state.memberfullname);
    formData.append("memberfirstname", this.state.memberfirstname);
    formData.append("memberlastname", this.state.memberlastname);
    formData.append("relationwithemployee", this.state.relationwithemployee);
    formData.append("suminsured", this.state.suminsured);
    formData.append("pincode", this.state.pincode);
    formData.append("gender", this.state.gender);
    formData.append("dob", this.state.dob);
    formData.append("mobilenumber", this.state.mobilenumber);
    formData.append("emailId", this.state.emailId);
    formData.append("employeeheight", this.state.employeeheight);
    formData.append("employeeweight", this.state.employeeweight);
    formData.append("bmi", this.state.bmi);
    formData.append("pannumber", this.state.pannumber);
    formData.append("aadharnumber", this.state.aadharnumber);
    formData.append("designation", this.state.designation);
    formData.append("alternatenumber", this.state.alternatenumber);
    formData.append("maritalstatus", this.state.maritalstatus);
    formData.append("city", this.state.city);
    formData.append("state", this.state.state);
    formData.append("memberstatus", this.state.memberstatus);
    formData.append("employmentstatus", this.state.employmentstatus);
    formData.append("addresslineone", this.state.addresslineone);
    formData.append("addresslinetwo", this.state.addresslinetwo);

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Healthmemberdata/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthmemberdatafetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            employeeid: "",
            companyid: "",
            memberfullname: "",
            memberfirstname: "",
            memberlastname: "",
            relationwithemployee: "",
            suminsured: "",
            pincode: "",
            gender: "",
            dob: "",
            mobilenumber: "",
            emailId: "",
            employeeheight: "",
            employeeweight: "",
            bmi: "",
            pannumber: "",
            aadharnumber: "",
            designation: "",
            alternatenumber: "",
            maritalstatus: "",
            city: "",
            state: "",
            memberstatus: "",
            employmentstatus: "",
            addresslineone: "",
            addresslinetwo: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  HealthmemberdataupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("employeeid", this.state.employeeid);
    formData.append("companyid", this.state.companyid);
    formData.append("memberfullname", this.state.memberfullname);
    formData.append("memberfirstname", this.state.memberfirstname);
    formData.append("memberlastname", this.state.memberlastname);
    formData.append("relationwithemployee", this.state.relationwithemployee);
    formData.append("suminsured", this.state.suminsured);
    formData.append("pincode", this.state.pincode);
    formData.append("gender", this.state.gender);
    formData.append("dob", this.state.dob);
    formData.append("mobilenumber", this.state.mobilenumber);
    formData.append("emailId", this.state.emailId);
    formData.append("employeeheight", this.state.employeeheight);
    formData.append("employeeweight", this.state.employeeweight);
    formData.append("bmi", this.state.bmi);
    formData.append("pannumber", this.state.pannumber);
    formData.append("aadharnumber", this.state.aadharnumber);
    formData.append("designation", this.state.designation);
    formData.append("alternatenumber", this.state.alternatenumber);
    formData.append("maritalstatus", this.state.maritalstatus);
    formData.append("city", this.state.city);
    formData.append("state", this.state.state);
    formData.append("memberstatus", this.state.memberstatus);
    formData.append("employmentstatus", this.state.employmentstatus);
    formData.append("addresslineone", this.state.addresslineone);
    formData.append("addresslinetwo", this.state.addresslinetwo);
    formData.append("healthmemberdata_Id", this.state.healthmemberdata_Id);

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Healthmemberdata/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthmemberdatafetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.HealthmemberdatafetchHandler();
    //this.HealthmemberdatastatusmemberfetchHandler();
    //this.HealthmemberdatastatuscountfetchHandler();
  }
  handleemployeeidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ employeeid: fieldValue });
  };
  handlecompanyidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ companyid: fieldValue });
  };
  handlememberfullnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ memberfullname: fieldValue });
  };
  handlememberfirstnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ memberfirstname: fieldValue });
  };
  handlememberlastnameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ memberlastname: fieldValue });
  };
  handlerelationwithemployeeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ relationwithemployee: fieldValue });
  };
  handlesuminsuredChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ suminsured: fieldValue });
  };
  handlepincodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ pincode: fieldValue });
  };
  handlegenderChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ gender: fieldValue });
  };
  handledobChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ dob: fieldValue });
  };
  handlemobilenumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ mobilenumber: fieldValue });
  };
  handleemailIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ emailId: fieldValue });
  };
  handleemployeeheightChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ employeeheight: fieldValue });
  };
  handleemployeeweightChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ employeeweight: fieldValue });
  };
  handlebmiChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ bmi: fieldValue });
  };
  handlepannumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ pannumber: fieldValue });
  };
  handleaadharnumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ aadharnumber: fieldValue });
  };
  handledesignationChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ designation: fieldValue });
  };
  handlealternatenumberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ alternatenumber: fieldValue });
  };
  handlemaritalstatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ maritalstatus: fieldValue });
  };
  handlecityChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ city: fieldValue });
  };
  handlestateChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ state: fieldValue });
  };
  handlememberstatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ memberstatus: fieldValue });
  };
  handleemploymentstatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ employmentstatus: fieldValue });
  };
  handleaddresslineoneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ addresslineone: fieldValue });
  };
  handleaddresslinetwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ addresslinetwo: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("healthmemberdata_Id", row.healthmemberdata_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Healthmemberdata/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthmemberdatafetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3
                        className="logoskybluecolor"
                        style={{ textAlign: "start" }}
                      >
                        Health Member Data
                      </h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Healthmemberdata page
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Employee Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleemployeeidChange}
                                        className="form-control"
                                        name="employeeid"
                                        value={this.state.employeeid}
                                        required="required"
                                        placeholder="Enter employeeid"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.employeeid}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Company Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlecompanyidChange}
                                        className="form-control"
                                        name="companyid"
                                        value={this.state.companyid}
                                        required="required"
                                        placeholder="Enter companyid"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.companyid}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Member Full Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlememberfullnameChange
                                        }
                                        className="form-control"
                                        name="memberfullname"
                                        value={this.state.memberfullname}
                                        required="required"
                                        placeholder="Enter memberfullname"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.memberfullname}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Member First Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlememberfirstnameChange
                                        }
                                        className="form-control"
                                        name="memberfirstname"
                                        value={this.state.memberfirstname}
                                        required="required"
                                        placeholder="Enter memberfirstname"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.memberfirstname}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Member Last Name
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlememberlastnameChange
                                        }
                                        className="form-control"
                                        name="memberlastname"
                                        value={this.state.memberlastname}
                                        required="required"
                                        placeholder="Enter memberlastname"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.memberlastname}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Relation With Employee
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlerelationwithemployeeChange
                                        }
                                        className="form-control"
                                        name="relationwithemployee"
                                        value={this.state.relationwithemployee}
                                        required="required"
                                        placeholder="Enter relationwithemployee"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {
                                        this.state.errors.relationwithemployee
                                      }{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Sum Insured
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlesuminsuredChange}
                                        className="form-control"
                                        name="suminsured"
                                        value={this.state.suminsured}
                                        required="required"
                                        placeholder="Enter suminsured"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.suminsured}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Pincode
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlepincodeChange}
                                        className="form-control"
                                        name="pincode"
                                        value={this.state.pincode}
                                        required="required"
                                        placeholder="Enter pincode"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.pincode}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Gender
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlegenderChange}
                                        className="form-control"
                                        name="gender"
                                        value={this.state.gender}
                                        required="required"
                                        placeholder="Enter gender"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.gender}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Date Of Birth
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="date"
                                        onChange={this.handledobChange}
                                        className="form-control"
                                        name="dob"
                                        value={this.state.dob}
                                        required="required"
                                        placeholder="Enter dob"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dob}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Mobile Number
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlemobilenumberChange}
                                        className="form-control"
                                        name="mobilenumber"
                                        value={this.state.mobilenumber}
                                        required="required"
                                        placeholder="Enter mobilenumber"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.mobilenumber}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Email Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleemailIdChange}
                                        className="form-control"
                                        name="emailId"
                                        value={this.state.emailId}
                                        required="required"
                                        placeholder="Enter emailId"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.emailId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Employee Height
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleemployeeheightChange
                                        }
                                        className="form-control"
                                        name="employeeheight"
                                        value={this.state.employeeheight}
                                        required="required"
                                        placeholder="Enter employeeheight"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.employeeheight}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Employee Weight
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleemployeeweightChange
                                        }
                                        className="form-control"
                                        name="employeeweight"
                                        value={this.state.employeeweight}
                                        required="required"
                                        placeholder="Enter employeeweight"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.employeeweight}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        BMI{" "}
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlebmiChange}
                                        className="form-control"
                                        name="bmi"
                                        value={this.state.bmi}
                                        required="required"
                                        placeholder="Enter bmi"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.bmi}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Pan Number
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handlepannumberChange}
                                        className="form-control"
                                        name="pannumber"
                                        value={this.state.pannumber}
                                        required="required"
                                        placeholder="Enter pannumber"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.pannumber}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Aadhar Number
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={this.handleaadharnumberChange}
                                        className="form-control"
                                        name="aadharnumber"
                                        value={this.state.aadharnumber}
                                        required="required"
                                        placeholder="Enter aadharnumber"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.aadharnumber}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Designation
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledesignationChange}
                                        className="form-control"
                                        name="designation"
                                        value={this.state.designation}
                                        required="required"
                                        placeholder="Enter designation"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.designation}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Alternate Number
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="number"
                                        onChange={
                                          this.handlealternatenumberChange
                                        }
                                        className="form-control"
                                        name="alternatenumber"
                                        value={this.state.alternatenumber}
                                        required="required"
                                        placeholder="Enter alternatenumber"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.alternatenumber}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Marital Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlemaritalstatusChange
                                        }
                                        className="form-control"
                                        name="maritalstatus"
                                        value={this.state.maritalstatus}
                                        required="required"
                                        placeholder="Enter maritalstatus"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.maritalstatus}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        City
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlecityChange}
                                        className="form-control"
                                        name="city"
                                        value={this.state.city}
                                        required="required"
                                        placeholder="Enter city"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.city}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        State
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlestateChange}
                                        className="form-control"
                                        name="state"
                                        value={this.state.state}
                                        required="required"
                                        placeholder="Enter state"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.state}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Member Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handlememberstatusChange}
                                        className="form-control"
                                        name="memberstatus"
                                        value={this.state.memberstatus}
                                        required="required"
                                        placeholder="Enter memberstatus"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.memberstatus}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Employment Status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleemploymentstatusChange
                                        }
                                        className="form-control"
                                        name="employmentstatus"
                                        value={this.state.employmentstatus}
                                        required="required"
                                        placeholder="Enter employmentstatus"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.employmentstatus}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        AddressLine one
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleaddresslineoneChange
                                        }
                                        className="form-control"
                                        name="addresslineone"
                                        value={this.state.addresslineone}
                                        required="required"
                                        placeholder="Enter addresslineone"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.addresslineone}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        Addressline Two
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handleaddresslinetwoChange
                                        }
                                        className="form-control"
                                        name="addresslinetwo"
                                        value={this.state.addresslinetwo}
                                        required="required"
                                        placeholder="Enter addresslinetwo"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.addresslinetwo}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.HealthmemberdatasubmitHandler}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div>
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={() => this.setState({ isEditing: false })}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>
                              Edit Health Memberdata Page
                            </Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container
                              style={{ overflowY: "auto", height: "auto" }}
                            >
                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Employee Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handleemployeeidChange}
                                          className="form-control"
                                          name="employeeid"
                                          value={this.state.employeeid}
                                          required="required"
                                          placeholder="Enter employeeid"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.employeeid}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Company Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlecompanyidChange}
                                          className="form-control"
                                          name="companyid"
                                          value={this.state.companyid}
                                          required="required"
                                          placeholder="Enter companyid"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.companyid}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Member Full Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlememberfullnameChange
                                          }
                                          className="form-control"
                                          name="memberfullname"
                                          value={this.state.memberfullname}
                                          required="required"
                                          placeholder="Enter memberfullname"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.memberfullname}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Member First Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlememberfirstnameChange
                                          }
                                          className="form-control"
                                          name="memberfirstname"
                                          value={this.state.memberfirstname}
                                          required="required"
                                          placeholder="Enter memberfirstname"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.memberfirstname}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Member Last Name
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlememberlastnameChange
                                          }
                                          className="form-control"
                                          name="memberlastname"
                                          value={this.state.memberlastname}
                                          required="required"
                                          placeholder="Enter memberlastname"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.memberlastname}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Relation With Employee
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this
                                              .handlerelationwithemployeeChange
                                          }
                                          className="form-control"
                                          name="relationwithemployee"
                                          value={
                                            this.state.relationwithemployee
                                          }
                                          required="required"
                                          placeholder="Enter relationwithemployee"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.relationwithemployee
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Sum Insured
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlesuminsuredChange}
                                          className="form-control"
                                          name="suminsured"
                                          value={this.state.suminsured}
                                          required="required"
                                          placeholder="Enter suminsured"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.suminsured}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Pincode
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlepincodeChange}
                                          className="form-control"
                                          name="pincode"
                                          value={this.state.pincode}
                                          required="required"
                                          placeholder="Enter pincode"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.pincode}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Gender
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlegenderChange}
                                          className="form-control"
                                          name="gender"
                                          value={this.state.gender}
                                          required="required"
                                          placeholder="Enter gender"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.gender}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Date Of Birth
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="date"
                                          onChange={this.handledobChange}
                                          className="form-control"
                                          name="dob"
                                          value={this.state.dob}
                                          required="required"
                                          placeholder="Enter dob"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.dob}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Mobile Number
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handlemobilenumberChange
                                          }
                                          className="form-control"
                                          name="mobilenumber"
                                          value={this.state.mobilenumber}
                                          required="required"
                                          placeholder="Enter mobilenumber"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.mobilenumber}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Email Id
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handleemailIdChange}
                                          className="form-control"
                                          name="emailId"
                                          value={this.state.emailId}
                                          required="required"
                                          placeholder="Enter emailId"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.emailId}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Employee Height
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleemployeeheightChange
                                          }
                                          className="form-control"
                                          name="employeeheight"
                                          value={this.state.employeeheight}
                                          required="required"
                                          placeholder="Enter employeeheight"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.employeeheight}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Employee Weight
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleemployeeweightChange
                                          }
                                          className="form-control"
                                          name="employeeweight"
                                          value={this.state.employeeweight}
                                          required="required"
                                          placeholder="Enter employeeweight"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.employeeweight}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          BMI{" "}
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlebmiChange}
                                          className="form-control"
                                          name="bmi"
                                          value={this.state.bmi}
                                          required="required"
                                          placeholder="Enter bmi"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.bmi}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Pan Number
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={this.handlepannumberChange}
                                          className="form-control"
                                          name="pannumber"
                                          value={this.state.pannumber}
                                          required="required"
                                          placeholder="Enter pannumber"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.pannumber}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Aadhar Number
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handleaadharnumberChange
                                          }
                                          className="form-control"
                                          name="aadharnumber"
                                          value={this.state.aadharnumber}
                                          required="required"
                                          placeholder="Enter aadharnumber"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.aadharnumber}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Designation
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handledesignationChange
                                          }
                                          className="form-control"
                                          name="designation"
                                          value={this.state.designation}
                                          required="required"
                                          placeholder="Enter designation"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.designation}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Alternate Number
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="number"
                                          onChange={
                                            this.handlealternatenumberChange
                                          }
                                          className="form-control"
                                          name="alternatenumber"
                                          value={this.state.alternatenumber}
                                          required="required"
                                          placeholder="Enter alternatenumber"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.alternatenumber}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Marital Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlemaritalstatusChange
                                          }
                                          className="form-control"
                                          name="maritalstatus"
                                          value={this.state.maritalstatus}
                                          required="required"
                                          placeholder="Enter maritalstatus"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.maritalstatus}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          City
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlecityChange}
                                          className="form-control"
                                          name="city"
                                          value={this.state.city}
                                          required="required"
                                          placeholder="Enter city"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.city}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          State
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={this.handlestateChange}
                                          className="form-control"
                                          name="state"
                                          value={this.state.state}
                                          required="required"
                                          placeholder="Enter state"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.state}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Member Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handlememberstatusChange
                                          }
                                          className="form-control"
                                          name="memberstatus"
                                          value={this.state.memberstatus}
                                          required="required"
                                          placeholder="Enter memberstatus"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.memberstatus}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Employment Status
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleemploymentstatusChange
                                          }
                                          className="form-control"
                                          name="employmentstatus"
                                          value={this.state.employmentstatus}
                                          required="required"
                                          placeholder="Enter employmentstatus"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {
                                          this.state.errors.employmentstatus
                                        }{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          AddressLine one
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleaddresslineoneChange
                                          }
                                          className="form-control"
                                          name="addresslineone"
                                          value={this.state.addresslineone}
                                          required="required"
                                          placeholder="Enter addresslineone"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.addresslineone}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label
                                          style={{ paddingTop: "8px" }}
                                        >
                                          Addressline Two
                                        </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control
                                          type="text"
                                          onChange={
                                            this.handleaddresslinetwoChange
                                          }
                                          className="form-control"
                                          name="addresslinetwo"
                                          value={this.state.addresslinetwo}
                                          required="required"
                                          placeholder="Enter addresslinetwo"
                                        />
                                      </Col>
                                      <div
                                        className="errorMsg"
                                        style={{ color: "red" }}
                                      >
                                        {" "}
                                        {this.state.errors.addresslinetwo}{" "}
                                      </div>
                                    </Row>
                                    <br />
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.HealthmemberdataupdateHandler}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                    </div>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
